<template>
  <div>
    <el-form :inline="true">
      <el-form-item label="设备：" style="width:360px">
        <el-select
          v-model="code"
          clearable
          filterable
          placeholder="请选择"
          style="width:300px"
          :loading="initing"
          @change="goSearch"
        >
          <el-option-group
            v-for="group in opts"
            :key="group.label"
            :label="group.label"
          >
            <el-option
              v-for="device in group.options"
              :key="device.key"
              :value="device.key"
              :label="`${device.city} | ${device.county} | ${device.site}`"
            >
              <span style="float: left">
                {{ device.site || device.county }}
              </span>
              <span style="float: right; color: #8492a6; font-size: 13px">
                {{ device.resolution }}
              </span>
            </el-option>
          </el-option-group>
        </el-select>
      </el-form-item>

      <el-popover
        trigger="click"
        placement="left-start"
        popper-class="padding-none"
      >
        <date-picker
          v-loading="loadingCount"
          :date="day"
          :date-count="dateCount"
          @change="dateChange"
          @pre-change="monthChange"
        ></date-picker>
        <el-button slot="reference">日期：{{ day }}</el-button>
      </el-popover>
    </el-form>
  </div>
</template>

<script>
import DatePicker from '@/components/DatePicker'
import { datePickOption } from '@/utlis/mixin'
import * as previewApi from '@/service/admin/preview'
import sleep from '@/utlis/sleep'
import _ from 'lodash'

export default {
  mixins: [datePickOption],
  components: { DatePicker },
  props: {
    loading: Boolean,
    loadingCount: Boolean,
    day: String,
    month: String,
    dateCount: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      initing: false,
      id: null,
      code: null,
      state: null,
      searchOpen: false,
      devs: [],
      opts: []
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.initing = true
      try {
        const [{ data }] = await Promise.all([previewApi.devs(), sleep(1)])
        this.devs = data

        let county = _.groupBy(data, 'county')
        let opts = []
        for (let k of Object.keys(county)) {
          let options = county[k]
          opts.push({ label: `${options[0].city} | ${k}`, options })
        }
        this.opts = opts
      } catch (e) {
        console.log(e)
      } finally {
        this.initing = false
      }
    },
    resetSearch() {
      this.code = null
      this.goSearch()
    },
    goSearch() {
      let dev = this.devs.find(d => d.key === this.code)
      this.$emit('change', dev)
    },
    dateChange(day) {
      if (day !== this.day) {
        this.$emit('date-change', day)
      }
    },
    monthChange(month) {
      if (month !== this.month) {
        if (!this.loading) this.$emit('month-change', month)
      }
    }
  }
}
</script>

<style lang="css" scoped></style>
